export enum EditMemberSidebarSteps {
  ChangePasswordNew = 'ChangePasswordNew',
  ChangePasswordOld = 'ChangePasswordOld',
  MailInvitation = 'MailInvitation',
  PasswordSaved = 'PasswordSaved',
}
